import { render, staticRenderFns } from "./ActiveLacksWidget.vue?vue&type=template&id=7882e8b6&scoped=true"
import script from "./ActiveLacksWidget.vue?vue&type=script&lang=js"
export * from "./ActiveLacksWidget.vue?vue&type=script&lang=js"
import style0 from "./ActiveLacksWidget.vue?vue&type=style&index=0&id=7882e8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7882e8b6",
  null
  
)

export default component.exports